export default __webpack_public_path__ + "static/media/ZippedFile_Failed.d6cec1a9.png";